export default __webpack_public_path__ + "static/media/logo1.87e23c04.png";